export default __webpack_public_path__ + "static/RUINSOFPEPE-a4f3d35b7a9f436254d117e4057f470e.png";